// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresGridUnpublishBody = {
  poolId: string;
  gridId: string;
};

export type typeSquaresGridUnpublishOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    grid: {
      gridId: string;
      gridState: "open" | "locked" | "live" | "final" | "void";
      publishStatus: "draft" | "published";
      hasNumbers: boolean;
    };
  };
};

export type typeSquaresGridUnpublishOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridUnpublishOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridUnpublishOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresGridUnpublishBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "gridId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresGridUnpublish(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresGridUnpublishBody);
  }

  return async function postSquaresGridUnpublish(
    payload: typeSquaresGridUnpublishBody,
  ): Promise<
    typeSquaresGridUnpublishOutput200 | typeSquaresGridUnpublishOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresGridUnpublish" failed before calling the network. #fcf235b3c4ff`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#fcf235b3c4ff" },
        },
        data: null,
      } as typeSquaresGridUnpublishOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/grid-unpublish`,
      httpMethod: "POST",
      options,
    })) as
      typeSquaresGridUnpublishOutput200 | typeSquaresGridUnpublishOutput400;
  };
}
